module.exports = __webpack_public_path__ + "img/sketch-consultant.ca7c5789.png";